import {
  INICIALIZED_SUCCESS,
  TOGGLE_ACTIVE_LEFT_MENU,
  SET_MESSENGERS_LIST,
  SET_SAVING_STATUS,
  TOGGLE_PHOTO_IS_DONE,
} from './constans';

let initialState = {
  inicialized: false,
  leftMenuActive: false,
  isPhotoDone: false,
  object: { photo: { photos: [], rejectedPhotos: [] } },
  baseUrl:
    window.location.host === 'edem-v-gosti.ru'
      ? 'https://edem-v-gosti.ru'
      : (window.location.host.includes('127.0') !== false || window.location.host.includes('localhost') !== false ? 'https://test.edem-v-gosti.ru' : `https://${window.location.host}`),
  isMobile:
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      navigator.userAgent
    ),
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_PHOTO_IS_DONE:
      return { ...state, isPhotoDone: action.payload };
    case INICIALIZED_SUCCESS:
      return {
        ...state,
        inicialized: true,
      };
    case TOGGLE_ACTIVE_LEFT_MENU:
      return {
        ...state,
        leftMenuActive: action.active,
      };

    case SET_MESSENGERS_LIST:
      return {
        ...state,
        messengers: action.messengers,
      };

    case SET_SAVING_STATUS:
      return {
        ...state,
        savingStatus: action.payload.status,
        errorMessage: action.payload.message,
      };

    default:
      return state;
  }
};

export default appReducer;
